module.exports = __webpack_public_path__ + "img/plataformas-memberkit.0c5decdd.svg";